ACC.zoom = {

	_autoload: [
		"imageGalleryZoom",
	],

	imageGalleryZoom: function () {
		$(document).on('click', '.image-gallery__zoom-icon', function(){

			var galleryHTML = $('.js-gallery-image-zoom').clone();
			galleryHTML.removeClass('hidden');

			ACC.colorbox.open("", {
				html: galleryHTML,
				top: "100px",
				fixed: true,
				// width: "615px",
				width: "900px",
				height: "700px",
				initialHeight: "700px",
				innerHeight: "700px",
				onComplete: function () {
					$('#colorbox').addClass('colorboxZoom');

					var $image = $('#cboxLoadedContent .js-gallery-image-zoom');

					$image.owlCarousel({
						singleItem: true,
						dots: false,
						nav: true,
						margin: 0,
						// autoWidth: true,
						navText: ["<span class='glyphicon glyphicon-chevron-left'></span>", "<span class='glyphicon glyphicon-chevron-right'></span>"],
						items: 1,
						rewind: true,
						responsive: {
							0: {
								nav: false
							},
							640: {
								nav: true
							}
						}
					});

					$(this).colorbox.resize();
				},
				onClosed: function () {
					$('#colorbox').removeClass('colorboxZoom');
				}
			});
    });
	}
};
